//dependencias
import React, { Component } from 'react';

//componentes
import ExpedienteNM from './expedienteNotasM'

class Index extends Component {

    render(){
        return(
            <div>
                <ExpedienteNM />
            </div>
        );
    }

}
export default Index;